import { FC, ReactNode } from 'react'
import { Flex, Grid } from '~/components/box'
import Link from '~/components/link'
import { Heading, SubHeading } from '~/components/text'

interface Props {
  title?: string
  description?: string
  actions?: ReactNode
}

const PageLevelError: FC<Props> = ({
  title = 'Well, this is awkward...',
  description = (
    <>
      An unknown error has occurred. Feel free to reach out to us at{' '}
      <Link
        href="mailto:help@happitu.com?subject=I ran into an error..."
        variant="secondary"
      >
        help@happitu.com
      </Link>
    </>
  ),
  actions,
}) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      style={{ height: 'calc(100vh - 115px)', width: '100%' }}
    >
      <Grid justifyItems="center" gridGap="medium">
        <img
          src="//assets.happitu.com/public/hiro-hiding.svg"
          alt="Hiding Hiro"
          style={{ height: 100 }}
        />
        <Heading>{title}</Heading>
        <SubHeading>{description}</SubHeading>
        <Grid>{actions}</Grid>
      </Grid>
    </Flex>
  )
}

export default PageLevelError
